export { VpTablePagination } from './VpTablePagination';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTablePagination/index.js